import { NgModule } from '@angular/core';
import { FormsModule } from '@angular/forms';
import { BrowserModule } from '@angular/platform-browser';
import { HttpClientModule } from '@angular/common/http';

import { NvD3Module } from '../../widgets/nvd3';
import { UIRouterModule } from '@uirouter/angular';

import { CoreServicesModule } from '../../core/core.services.module';
import { CoreFiltersModule } from '../../core/core.filters.module';
import { CoreWidgetsModule } from '../../widgets/core.widgets.module';
import { TrackerLibModule } from '../tracker/lib/tracker.lib.module';
import { FRS_STATES } from './frs.routes.config';

// ngUpgrade Angular core services module
// Import converted service classes in ./services here
// Add to providers array, below
// Then go back to core.services.module.ajs.ts and register the downgraded service
import { FrsReleaseService } from './services/frs.release.service';
import { PackageModelService } from './services/frs.package.model.service';
import { FrsPackageService } from './services/frs.package.service';
import { FrsResolvesService } from './frs-resolves.service';

import { FrsReleaseHelper } from './services/frs.release.helper.service';
import { FrsReleaseBrowseService } from './services/frs.release-browse.service';
import { FrsReleaseDisplayService } from './services/frs.release-display.service';
import { FrsReleaseTiService } from './services/frs.release-ti.service';
import { FrsReleaseChartsService } from './services/frs.release-charts.service';
import { ReleaseModel } from './services/frs.release.model.service';

import { FrsTabsComponent } from './frsTabs/frs.tabs.component';
import { FrsReleaseFilesComponent } from './frsFiles/frs.files.component';
import { FrsPackageEditComponent } from './frsPackageEdit/frs.package.edit.component';
import { FrsReleaseEditComponent } from './frsReleaseEdit/frs.release.edit.component';
import { FrsProgressBarComponent } from './frsProgressbar/frs.progress.bar.component';

import { FrsRoadmapComponent } from './frsRoadmap/frs.roadmap.component';
import { FrsBrowseComponent } from './frsBrowse/frs.browse.component';
import { FrsReleaseDetailsComponent } from './frsReleaseDetails/frs.release.details.component';

@NgModule({
    imports: [
        BrowserModule,
        HttpClientModule,
        FormsModule,
        NvD3Module,
        CoreFiltersModule,
        CoreServicesModule,
        CoreWidgetsModule,
        TrackerLibModule,
        UIRouterModule.forChild({ states: FRS_STATES })
    ],
    providers: [
        FrsReleaseService,
        PackageModelService,
        FrsPackageService,
        FrsResolvesService,
        FrsReleaseHelper,
        FrsReleaseBrowseService,
        FrsReleaseDisplayService,
        FrsReleaseTiService,
        FrsReleaseChartsService,
        ReleaseModel
    ],
    declarations: [
        FrsTabsComponent,
        FrsReleaseFilesComponent,
        FrsPackageEditComponent,
        FrsReleaseEditComponent,
        FrsProgressBarComponent,
        FrsRoadmapComponent,
        FrsBrowseComponent,
        FrsReleaseDetailsComponent,
    ],
})
export class FrsModule {
    constructor() { }
}